import React from 'react';
import { Button, PageHeader } from '@ver-uds/react';
import { useHistory } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { SkipNav } from '@ver-uds/uswds-react';

const NotFound = (): JSX.Element => {
  const history = useHistory();
  return (
    <HelmetProvider>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <SkipNav.MainContent>
        <PageHeader variant="error">404 - Page Not Found</PageHeader>
        <div className="grid-container">
          <section className="usa-section padding-top-4">
            <h2>The requested page cannot be found</h2>
            <p>Please check the address, try again, or go back.</p>
            <Button className="margin-top-5" onClick={() => history.goBack()}>
              Go Back
            </Button>
          </section>
        </div>
      </SkipNav.MainContent>
    </HelmetProvider>
  );
};

export default NotFound;
